@if (showFullpageModal) {
<div class="fullpage-modal" (click)="clearFullpageModal()" (dblclick)="doubleClick()"></div>
}
<div class="h-100 eng-drawing">
  <div class="row w-100 headerWrapper mx-0" [style.height.px]="headerHeight">
    @if (application$ | async; as application) {
    <div class="navbar fixed-top container-fluid pl-0" #fixedHeader>
      <dnv-mood-canvas class="dnv-mood-canvas"></dnv-mood-canvas>
      <div class="row w-100 mx-0 d-flex header">
        <div class="pl-0">
          <h1 class="navbar-brand" title="GeoTools">Geotools</h1>
        </div>
        <div class="ml-auto d-flex justify-content-end copy-url">
          @if (isDrawingSelected()) {
          <div>
            {{ nbOfDrawingSelected() }} Drawings Selected.
            <button class="btn btn-outline-primary ml-2" type="button" (click)='copyUrlsToClipboard()'>Copy
              URL(s)</button>
            <button class="btn btn-outline-primary ml-2" type="button" (click)='downloadFile()'>Download PDF(s)</button>
          </div>
          }
        </div>
      </div>
    </div>
    }

  </div>
  <div class="row w-100 mx-0">

    <div [style.height.px]="drawingHeight" [style.width.px]="gridWidth" [hidden]="gridWidth < 25">
      <div class="row w-100 mx-0">
        <ejs-grid #grid [height]="gridHeight" [width]='gridWidth' [dataSource]='drawings' [columns]='columns'
          [allowFiltering]='true' [filterSettings]='filterOption' [allowSorting]='true' [allowResizing]='true'
          [selectionSettings]="selectionOptions" (rowSelected)='rowSelected($event)'
          (rowDeselected)='rowDeSelected($event)' (rowDataBound)='rowBound($event)' (created)='gridCreated()'
          (rowSelecting)="toggleSelecting($event)" (rowDeselecting)="toggleSelecting($event)">
        </ejs-grid>
        <ng-template #projectName let-data>
          <a href="./engdrawings;projectName={{data.projectName}}" rel="nofollow noopener">{{data.projectName}}</a>
        </ng-template>
        <ng-template #docNum let-data>
          <button type="button" class="no-select btn btn-link">{{data.number}}</button>
        </ng-template>
      </div>
    </div>

    <div class="d-none d-md-block handler" #divider [style.height.px]="drawingHeight" (click)="handlerClick()"
      (dblclick)="doubleClick()"></div>

    <div class="d-none d-md-block" [style.width.px]="applicationState.windowInnerWidth - gridWidth - 10">
      <!-- @if (!singleDrawingSelected()) {
      <div>
        <p class="text-center mt-4">
          {{ drawingFrameMessage() }}
        </p>
      </div>
      }-->
      <!-- @if (singleDrawingSelected()) {
      <div> -->
      @if (isSensitive) {
      <div class="pdf-sensitive text-center p-2">** SENSITIVE DRAWING **</div>
      }
      <!-- </div>
      }  -->
      <!-- need to be rendered else viewer is undefined on first click of pdf -->
      <!-- @if (isDrawingSelected()) { -->

      @if (selectedDrawingUrl?.length === 0 || !selectedDrawingUrl || selectedDrawingUrl === undefined) {
      <div class='text-center mt-4'>
        Click on drawing number to view.
      </div>
      }
      <ng2-pdfjs-viewer #pdfViewer cursor="Hand" [showSpinner]="false" locale='en-US'>
      </ng2-pdfjs-viewer>

    </div>

  </div>

</div>